import { render, staticRenderFns } from "./TransferOfOwnership.vue?vue&type=template&id=465e0910"
import script from "./TransferOfOwnership.vue?vue&type=script&lang=js"
export * from "./TransferOfOwnership.vue?vue&type=script&lang=js"
import style0 from "./TransferOfOwnership.vue?vue&type=style&index=0&id=465e0910&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports